import { render, staticRenderFns } from "./upcoming-lectures-component.vue?vue&type=template&id=5ee30fc8&scoped=true"
import script from "./upcoming-lectures-component.vue?vue&type=script&lang=js"
export * from "./upcoming-lectures-component.vue?vue&type=script&lang=js"
import style0 from "./upcoming-lectures-component.vue?vue&type=style&index=0&id=5ee30fc8&prod&scoped=true&lang=css"
import style1 from "./upcoming-lectures-component.vue?vue&type=style&index=1&id=5ee30fc8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee30fc8",
  null
  
)

export default component.exports